import React from 'react';

const Loader = () => {
    return <div className="p-5 w-100 text-center black-text">
        <p>LOADING, PLEASE WAIT...</p>
        <i className="fa fa-spinner fa-pulse fa-3x fa-fw" aria-hidden="true"></i>
    </div>;
}

export default Loader;